import React, { Component } from "react"
import { getCategories, addQuestion } from "../services/Api"
import { toast } from "react-toastify"
import { Select } from "antd"
import { connect } from "react-redux"
const { Option } = Select

class MasterForm extends Component {
	constructor(props) {
		super(props)
		this.state = {
			currentStep: 1,
			question: "",
			category: "",
			password: "",
			recommendations: [],
			categories: [],
		}
	}

	handleChange = (event) => {
		const { name, value } = event.target
		this.setState({
			[name]: value,
		})
	}

	handleSelect = (event) => {
		this.setState({
			category: event,
		})
	}
	handleSubmit = async (event) => {
		event.preventDefault()
		const data = {
			user_id: this.props.currentUser._id,
			category_id: this.state.category,
			question: this.state.question,
		}
		const newQuestion = await addQuestion(data)
		toast(newQuestion.message, { type: "success" })
		this.setState({
			question: "",
			category: "",
		})
	}

	_next = async () => {
		let currentStep = this.state.currentStep
		// const email = this.state.email
		currentStep = currentStep >= 2 ? 3 : currentStep + 1
		this.setState({
			currentStep: currentStep,
		})
	}

	_prev = () => {
		let currentStep = this.state.currentStep
		// const email = this.state.email

		currentStep = currentStep <= 1 ? 1 : currentStep - 1
		this.setState({
			currentStep: currentStep,
		})
	}

	/*
	 * the functions for our button
	 */
	previousButton() {
		let currentStep = this.state.currentStep
		if (currentStep !== 1) {
			return (
				<div className='addQuestion'>
					<button
						className='btn btn-secondary'
						type='button'
						onClick={this._prev}
					>
						Previous
					</button>
				</div>
			)
		}
		return null
	}

	nextButton() {
		let currentStep = this.state.currentStep
		if (currentStep < 3) {
			return (
				<div className='addQuestion'>
					<button
						className='btn btn-primary float-right '
						type='button'
						onClick={this._next}
					>
						Next
					</button>
				</div>
			)
		}
		return null
	}

	submitButton() {
		let currentStep = this.state.currentStep
		if (currentStep > 2) {
			return (
				<div className='addQuestion'>
					<button
						className='btn btn-primary float-right '
						type='button'
						onClick={this.handleSubmit}
					>
						Submit
					</button>
				</div>
			)
		}
		return null
	}

	async componentDidMount() {
		const categories = await getCategories()

		this.setState({
			categories: categories,
		})
	}
	render() {
		return (
			<React.Fragment>
				<h1>Add a New Question <span role="img" aria-label="wizard">🧙‍♂️</span></h1>
				<p>Step {this.state.currentStep} </p>

				<form onSubmit={this.handleSubmit}>
					{/* 
          render the form steps and pass required props in
        */}
					<Step1
						currentStep={this.state.currentStep}
						handleChange={this.handleChange}
						question={this.state.question}
					/>
					<Step2
						currentStep={this.state.currentStep}
						handleChange={this.handleSelect}
						data={this.state.categories}
						category={this.state.category}
					/>
					<Step3
						currentStep={this.state.currentStep}
						handleChange={this.handleChange}
						recommendations={this.state.recommendations}
						password={this.state.password}
					/>
					<div className='twoButtons'>
						<div className='button1'> {this.previousButton()}</div>
						<div className='button1'> {this.nextButton()}</div>
						<div className='button1'> {this.submitButton()}</div>
					</div>
				</form>
			</React.Fragment>
		)
	}
}

function Step1(props) {
	if (props.currentStep !== 1) {
		return null
	}
	return (
		<div className='form-group'>
			<input
				className='questionSteps'
				id='question'
				name='question'
				type='text'
				placeholder='Please write the Question?'
				value={props.question}
				onChange={props.handleChange}
			/>
		</div>
	)
}

function Step2(props) {
	if (props.currentStep !== 2) {
		return null
	}
	return (
		<div className='form-group'>
			<label htmlFor='username'>
				Select the Category of the question
			</label>

			<Select
				showSearch
				style={{ width: "100%" }}
				placeholder='Select the category'
				optionFilterProp='children'
				onSelect={props.handleChange}
				value={props.category}
				filterOption={(input, option) =>
					option.children
						.toLowerCase()
						.indexOf(input.toLowerCase()) >= 0
				}
			>
				{props.data.map((item) => (
					<Option value={item._id}>{item.categoryName}</Option>
				))}
			</Select>
		</div>
	)
}

function Step3(props) {
	if (props.currentStep !== 3) {
		return null
	}
	return <React.Fragment></React.Fragment>
}

function mapStateToProps({ currentUser }) {
	return {
		currentUser: currentUser,
	}
}

export default connect(mapStateToProps)(MasterForm)
